import { render, staticRenderFns } from "./addPromotion.vue?vue&type=template&id=338f5286"
import script from "./addPromotion.vue?vue&type=script&lang=js"
export * from "./addPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports